import type { ParseJSONObject } from '@ikegps/core-api';
import type { IkeRestDepartment } from '../rest.department';

/** Defines how to query an object */
export interface IkeCacheObject<U> {
	className: string;
	actionName: string;
	/**
	 * Typescript seems to need this type here otherwise it complains about not knowing how to resolve the generic
	 * TODO check every few releases to see if we still need it.
	 */
	object?: U;

	canCache<K extends keyof U>(key: K): boolean;
	updateCache?<K extends keyof U>(key: K, result: U, rest: IkeRestDepartment);
}

export abstract class IkeRestObject<U extends ParseJSONObject = ParseJSONObject> implements IkeCacheObject<U> {
	abstract className;
	abstract actionName;
	/**
	 * @see IkeCacheObject.object
	 */
	abstract object?: U;

	cacheKeys = {
		objectId: true,
	};

	canCache<K extends keyof U>(key: K): boolean {
		return this.cacheKeys[key as string];
	}

	updateCache?<K extends keyof U>(key: K, result: U, rest: IkeRestDepartment) {
		return;
	}

	protected cacheIfLatest<K extends keyof U>(key: K, result: U, rest: IkeRestDepartment) {
		if (result == null) {
			return;
		}

		const value = result[key] as any;

		const newFetchable = rest.getOne(this, key, value);

		if (newFetchable.hasFetched) {
			if (newFetchable.value == null || newFetchable.value.updatedAt < result.updatedAt) {
				newFetchable.init(result);
			}
		} else if (!newFetchable.isFetching) {
			newFetchable.init(result);
		}
	}
}
